import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddState = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 14,
	viewBox: "0 0 21 14",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#4A5666",
		fillRule: "nonzero",
		children: [/* @__PURE__ */ _jsx("path", { d: "M10.5 0C16.263 0 21 3.069 21 7h-1.5c0-2.977-3.995-5.5-9-5.5s-9 2.523-9 5.5 3.995 5.5 9 5.5c.87 0 1.708-.076 2.5-.217v1.52c-.802.129-1.64.197-2.5.197C4.737 14 0 10.931 0 7s4.737-7 10.5-7" }), /* @__PURE__ */ _jsx("path", { d: "M18.25 7v2.75H21v1.5h-2.75V14h-1.5v-2.75H14v-1.5h2.75V7z" })]
	})
});
export default SvgAddState;
